<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButtonMenu
            type="secundario"
            :options="operacoesOptions"
            @click="op => selectOperacao(op)"
            :loading="loadingAcao"
          >
            Operação em massa
          </FormButtonMenu>
          <FormButtonMenu
            type="secundario"
            :options="planilhaOptions"
            @click="op => selectOperacao(op)"
          >
            Operação em planilha
          </FormButtonMenu>
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        sortBy="nome"
        :sortDesc="false"
        ref="datatable"
        showSelect
        search
        noHideFilters
        v-model="produtoSelecionados"
        :auto-search="false"
        :limitPage="[10, 20, 30, 40, 50, 100, 200, 500]"
      >
        <template v-slot:nome="{ row }">
          <div>
            <strong>{{ row.nome }}</strong>
            <div v-if="row.id_produto_erp" class="text-caption text--secondary">
              Código: {{ row.id_produto_erp }}
            </div>
            <div v-if="row.codigobarras" class="text-caption text--secondary">
              Código de barras: {{ row.codigobarras }}
            </div>
          </div>
        </template>
        <template v-slot:estoque_atual="{ row }">
          {{ row.estoque_atual || 0 }}
        </template>
        <template v-slot:tipo_calculo="{ row }">
          <FormSelect
            v-model="row.tipo_calculo"
            :options="tipoCalculoOptions"
            dense
            @change="
              value => onChangeEstoqueSeguranca(row, 'tipo_calculo', value)
            "
            placeholder="Selecione"
            class="pt-3 mb-n3"
            clearable
            :disabled="loadingRow[row.idcadastroextraproduto]"
          />
        </template>
        <template v-slot:valor_aplicado="{ row }">
          <FormField
            v-model="row.valor_aplicado"
            typeField="number"
            dense
            @blur="
              value => onChangeEstoqueSeguranca(row, 'valor_aplicado', value)
            "
            placeholder="Valor"
            :min="0"
            class="pt-3 mb-n3"
            :disabled="loadingRow[row.idcadastroextraproduto]"
          />
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <EstoqueSegurancaModal
        v-if="modalAtualizarEstoqueSeguranca"
        @close="modalAtualizarEstoqueSeguranca = false"
        @submit="aplicarEstoqueSeguranca"
      />
    </transition>
    <transition name="slide-popup" mode="out-in">
      <EdicaoEmPlanilha
        v-if="modalEdicaoEmPlanilha.open"
        :modelo="modalEdicaoEmPlanilha.modelo"
        @close="modalEdicaoEmPlanilha.open = false"
      />
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import { mapGetters } from "vuex";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import {
  PRODUTO_UPDATE_ESTOQUE_SEGURANCA,
  PRODUTO_UPDATE_ESTOQUE_SEGURANCA_MASSA
} from "@/store/actions/produto";
import EstoqueSegurancaModal from "./EstoqueSegurancaModal";
import EdicaoEmPlanilha from "@/components/EdicaoEmPlanilha";

export default {
  name: "EstoqueSegurancaTable",
  components: {
    DataTable,
    Panel,
    MarketingModules,
    FormSelect,
    FormField,
    FormButtonMenu,
    FormButtonGroup,
    EstoqueSegurancaModal,
    EdicaoEmPlanilha
  },
  data: () => ({
    headers: [
      { text: "Produto", value: "nome" },
      { text: "Unidade de venda", value: "unidade", align: "center" },
      {
        text: "Estoque integrado",
        value: "estoque_integrado",
        align: "center"
      },
      {
        text: "Estoque atual",
        value: "estoque_atual",
        align: "center"
      },
      {
        text: "Tipo de cálculo",
        value: "tipo_calculo",
        align: "center"
      },
      {
        text: "Valor aplicado",
        value: "valor_aplicado",
        align: "center"
      }
    ],
    tipoCalculoOptions: [
      { text: "Percentual", value: "percentual" },
      { text: "Fixo", value: "fixo" }
    ],
    operacoesOptions: [
      {
        text: "Atualizar estoque de segurança",
        value: "atualizar_estoque_seguranca"
      }
    ],
    planilhaOptions: [
      {
        text: "Editar estoque de segurança",
        value: "planilha_estoque_seguranca"
      }
    ],
    produtoSelecionados: [],
    modalAtualizarEstoqueSeguranca: false,
    modalEdicaoEmPlanilha: {
      open: false,
      modelo: "planilha_estoque_seguranca"
    },
    loadingAcao: false,
    loadingRow: {},
    modulosForm: [
      ModulesEnum.PORTFOLIO_WEB,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ]
  }),
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "moduloFornecedorAtivo",
      "getFornecedorTag"
    ]),
    tipoVenda() {
      return [
        { text: "Todos", value: "" },
        { text: "Avulso", value: "AVULSO" },
        { text: "Recorrência", value: "RECORRENCIA" },
        { text: "Sob Demanda", value: "SOB_DEMANDA" },
        { text: "Adicional", value: "ADICIONAL" }
      ];
    },
    filters() {
      return [
        { label: "Código de barras", query: "codigobarras" },
        { label: "Código interno", query: "codigointerno" },
        { label: "Agrupador de embalagem", query: "agrupador" },
        {
          label: "Categoria",
          query: "categoria",
          type: "autocomplete",
          request: {
            value: "idsetor",
            text: "descricao",
            endpoint: `/api/web/internal/v2/setores-produto/get/setores/${this.getFornecedorId}`,
            query: "search",
            clearable: true
          }
        },
        {
          label: "Disponibilidade",
          query: "disponibilidade",
          default: "",
          options: [
            { text: "Todos", value: "" },
            { text: "Disponível", value: "true" },
            { text: "Indisponível", value: "false" }
          ]
        },
        {
          label: "Vínculo de imagem",
          query: "temimagem",
          options: [
            { text: "Todos", value: "" },
            { text: "Com imagem", value: "true" },
            { text: "Sem imagem", value: "false" }
          ]
        },
        {
          label: "Tipo venda",
          query: "tipovenda",
          options: this.tipoVenda
        },
        {
          label: "Categorização",
          query: "temcategoria",
          options: [
            { text: "Todos", value: "" },
            { text: "Categorizado", value: "true" },
            { text: "Não categorizado", value: "false" }
          ]
        },
        {
          label: "Exibe se indisponível",
          query: "ativo",
          default: "",
          options: [
            { text: "Todos", value: "" },
            { text: "Sim", value: "true" },
            { text: "Não", value: "false" }
          ]
        },
        {
          label: "Venda fracionada",
          query: "fracionado",
          options: [
            { text: "Todos", value: "" },
            { text: "Com venda fracionada", value: "true" },
            { text: "Sem venda fracionada", value: "false" }
          ]
        },
        {
          label: "Múltiplo",
          query: "multiplo",
          options: [
            { text: "Todos", value: "" },
            { text: "Com múltiplo", value: "true" },
            { text: "Sem múltiplo", value: "false" }
          ]
        },
        {
          label: "Cód. Filial ERP",
          query: "codfilialerp",
          type: "autocomplete",
          multiple: true,
          request: {
            value: "cod_filial_erp",
            text: "descricao",
            endpoint: `/api/v4/product/cod-filial-erp/${this.getFornecedorId}`,
            query: "search"
          }
        }
      ];
    },
    endpoint() {
      return `/api/v4/product/estoque-seguranca/${this.getFornecedorId}/datatable`;
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  },
  watch: {
    getFornecedorId: {
      handler() {
        this.loadData();
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadingRow = {};
    },
    selectOperacao(option) {
      const edicaoPlanilha = option.value.startsWith("planilha");
      if (edicaoPlanilha) {
        this.modalEdicaoEmPlanilha = {
          open: true,
          modelo: option.value
        };
        return;
      }
      if (this.produtoSelecionados.length == 0) {
        this.$vueOnToast.pop(
          "warning",
          "Necessário selecionar ao menos um produto para aplicar operações em massa"
        );
        return;
      }
      switch (option.value) {
        case "atualizar_estoque_seguranca":
          this.modalAtualizarEstoqueSeguranca = true;
          break;
      }
    },
    aplicarEstoqueSeguranca(estoqueSeguranca) {
      this.modalAtualizarEstoqueSeguranca = false;
      this.loadingAcao = true;
      const arrayIdsProdutos = this.produtoSelecionados.map(
        item => item.idcadastroextraproduto
      );
      this.$store
        .dispatch(PRODUTO_UPDATE_ESTOQUE_SEGURANCA_MASSA, {
          idfornecedor: this.getFornecedorId,
          idscadastroextra: arrayIdsProdutos,
          tipo_calculo: estoqueSeguranca.tipo_calculo,
          valor_aplicado: estoqueSeguranca.valor_aplicado
        })
        .then(() => {
          this.loadingAcao = false;
          this.$vueOnToast.pop(
            "success",
            "Estoque de segurança atualizado com sucesso!"
          );
          this.$refs.datatable.reload();
        })
        .catch(err => {
          this.loadingAcao = false;
          this.$vueOnToast.pop(
            "error",
            err.response?.data?.message ||
              "Erro ao atualizar estoque de segurança"
          );
        });
    },
    onChangeEstoqueSeguranca(row, field, value) {
      if (!row.idcadastroextraproduto) {
        return;
      }

      if (field === "tipo_calculo") {
        row.tipo_calculo = value;
      } else if (field === "valor_aplicado") {
        row.valor_aplicado = value;
      }

      this.$nextTick(() => {
        let tipo_calculo = row.tipo_calculo;
        if (
          tipo_calculo === undefined ||
          tipo_calculo === null ||
          tipo_calculo === ""
        ) {
          tipo_calculo = null;
        }

        let valor_aplicado = row.valor_aplicado;
        if (
          valor_aplicado !== undefined &&
          valor_aplicado !== null &&
          valor_aplicado !== ""
        ) {
          valor_aplicado =
            typeof valor_aplicado === "string"
              ? parseFloat(valor_aplicado)
              : Number(valor_aplicado);
          if (isNaN(valor_aplicado)) {
            valor_aplicado = null;
          }
        } else {
          valor_aplicado = null;
        }

        this.loadingRow = {
          ...this.loadingRow,
          [row.idcadastroextraproduto]: true
        };

        this.$store
          .dispatch(PRODUTO_UPDATE_ESTOQUE_SEGURANCA, {
            idcadastroextraproduto: row.idcadastroextraproduto,
            tipo_calculo: tipo_calculo,
            valor_aplicado: valor_aplicado
          })
          .then(() => {
            this.$vueOnToast.pop(
              "success",
              "Estoque de segurança atualizado com sucesso"
            );
            this.loadingRow = {
              ...this.loadingRow,
              [row.idcadastroextraproduto]: false
            };
          })
          .catch(err => {
            this.$vueOnToast.pop(
              "error",
              err.response?.data?.message ||
                "Erro ao atualizar estoque de segurança"
            );
            this.loadingRow = {
              ...this.loadingRow,
              [row.idcadastroextraproduto]: false
            };
          });
      });
    }
  }
};
</script>
